// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","orderForm":"PlaceOrderForm_orderForm__3ZvoB","submitButton":"PlaceOrderForm_submitButton__51Qj3"};